import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ModificarEstadoAlarmaListaService = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Alarma/ModificarEstadoAlarmaLista",
         values, customConfig);
        return resultado
    } catch (error) {
        console.log(error);
    }
}
export { ModificarEstadoAlarmaListaService };